<template>
  <div class="planManage" style="position: relative;">


    <a-page-header style="border-bottom: 1px solid rgb(235, 237, 240);padding-left: 20px;" title="随心推-任务进度"
      sub-title="任务进度" />
    <a-statistic-countdown :title="deadtitle" :value="deadline" @finish="onFinish" style="padding-top:10px" />

    <div style="padding:10px 20px">
      <a-tabs default-active-key="1" @change="changeTopTab"
        :tabBarStyle="{ display: 'flex', justifyContent: 'flex-start', position: 'relative' }">
        <a-tab-pane tab="全部任务" key="1">
        </a-tab-pane>
        <a-tab-pane tab="短视频任务" key="2">
        </a-tab-pane>
        <a-tab-pane tab="直播任务" key="3">
        </a-tab-pane>
        <a-tab-pane tab="等待执行" key="4">
        </a-tab-pane>
        <a-tab-pane tab="执行错误" key="5">
        </a-tab-pane>
      </a-tabs>

      <div class="searchWapper">
        <a-form-model layout="inline">

          <a-form-model-item label="" style="padding-top: 3px;">
            <AwemeList :dataSource="advertiserList" action="setAdvertiserId" @getAdvertiserId="getAdvertiserId"
              v-if="advertiserList.length > 0" />
          </a-form-model-item>

          <a-form-model-item label="">
            <a-button type="primary" style="margin-right: 15px" @click="searchData"> 查询 </a-button>
            <a-button>重置</a-button>
 
            <b style="margin-left:20px;font-size:14px" v-if="!advertiser_id">
              【全部账户】 今日共创建任务数：<span style="color:#000">{{today_count}}</span> 条，共创建计划：<span style="color:#000">{{today_success+today_error}}</span> 笔，其中成功计划：<span style="color:green">{{today_success}}</span> 笔，失败计划：<span style="color:red">{{today_error}}</span> 笔
            </b>
            <b style="margin-left:20px;font-size:14px" v-else>
              【当前账户：{{ advertiser_id }}】今日共创建任务数：<span style="color:#000">{{today_count}}</span> 条，共创建计划：<span style="color:#000">{{today_success+today_error}}</span> 笔，其中成功计划：<span style="color:green">{{today_success}}</span> 笔，失败计划：<span style="color:red">{{today_error}}</span> 笔
            </b>

          </a-form-model-item>
          


        </a-form-model>
      </div>
    
      <Planlist ref="plan" :advertiser_id="advertiser_id" :timeType="timeType" @getTasklist="getData"/>



    </div>





  </div>
</template>
<script>
import { qcApi, requestHttp } from '@utils/index';
import { Modal } from 'ant-design-vue';
import awemeList from '../batchCreatePlan/components/awemeList.vue';
import aweme_avatar from '@/assets/images/sxt.png'
import planlist from "./components/list.vue" 
const key = 'updatable';
export default {
  name: 'planManage',
  props: {}, 
  data() {
    return { 
      advertiserList: [],
      advertiser_id: '',
       
      deadline: Date.now() + 1000 * 11,
      deadtitle: '定时刷新中：倒计时',
    
      timeType: '',
      spinning:false,
      today_count:0,
      today_success:0,
      today_error:0,

      topkey:'1',
    };
  },

  components: {
    AwemeList: awemeList,
    Planlist:planlist
  },

  watch: {},
  async mounted() {
    await this.getAdvertiserList()
  },
  methods: { 
    changeTopTab(e) {
      if (e == 1) {
        this.timeType = ''
      } else if (e == 2) {
        this.timeType = 'VIDEO_PROM_GOODS'
      } else if (e == 3) {
        this.timeType = 'LIVE_PROM_GOODS'
      }else if (e == 4) {
        this.timeType = 'WAIT'
      }else if (e == 5) {
        this.timeType = 'ERROR'
      }
    },
    getAdvertiserId(advertiser_id) {
      console.log('子组件传回的值', advertiser_id)
      this.advertiser_id = advertiser_id
      this.$refs.plan.getData()
    },
    onFinish() {
      this.$message.loading({ content: '刷新中...', key });
      this.deadtitle = '定时刷新中：正在刷新...';
      // this.getData();
      this.$refs.plan.getData();
      setTimeout(() => {
        this.$message.success({ content: '刷新成功!', key, duration: 2 });
        this.deadtitle = '定时刷新中：倒计时'
        this.deadline = Date.now() + 1000 * 11
      }, 1000);
    },
    async getAdvertiserList() {
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.GET_ADVERTISER_LIST}`,
        method: 'POST',
        params: {
          type: 'SXT',
        },
      });
      if (code == 0) {
        this.$message.error(msg);
        return;
      }
      if (!data) return;
      let dataSource = [{ advertiser_id: '', aweme_name: '全部账户', aweme_id: '', aweme_avatar: aweme_avatar }];

      if (data.list.length == 0) {
        Modal.confirm({
          title: '提醒',
          content: '您尚未授权随心推账户，是否前往授权？',
          onOk: () => {
            this.$router.replace('/sxt_account');
          },
        });
      } else {
        data.list.forEach(function (item) {
          dataSource.push(item)
        })
        this.advertiserList = dataSource
        this.advertiser_id = dataSource[0].advertiser_id
      }
      this.$refs.plan.getData();
    },  
    async getData(data) {
      this.today_count = data.today_count
      this.today_success = data.today_success
      this.today_error = data.today_error
    },
    searchData() {
      this.$refs.plan.getData();
    },
  },
};
</script>

<style lang="less" scoped>
.planManage {
  .searchWapper {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    position: relative;

    .selectType {
      width: 166px;
    }
  }

  .searchResult {
    margin-top: 20px;
  }
}

.ant-statistic {
  position: absolute;
  right: 20px;
  top: 0px;
}

.videoimg {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  cursor: pointer;
}
.aweme {
  display: flex;
}
.videoimg {
  width: 50px;
  height: 70px;
  border-radius: 3px;
  cursor: pointer;
}
.aweme-right {
  padding-left:30px;
  text-align: left;
  padding-left: 10px;
  width: 180px;
  .aweme-title {
    color: #000;
    font-weight: bold; 
    cursor: pointer;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 200px;
  }
}
.planManage {
  .searchWapper {
    display: flex;
    align-items: center;
    justify-content: flex-start;

    .selectType {
      width: 166px;
    }
  }

  .searchResult {
    margin-top: 20px;
  }
} 
.awemeimg {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  cursor: pointer;
}  
/deep/ .mainWapper {
  padding-bottom: 80px !important;
}
.mainContent {
  padding-bottom: 30px !important;
}
</style>
